import {Injectable, Injector} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AppConfigService<T> {
    private appConfig?: T

    constructor(private injector: Injector) {
    }

    public loadAppConfig() {
        let http = this.injector.get(HttpClient);

        return http.get('assets/app-config.json')
            .toPromise()
            .then(data => {
                this.appConfig = data as T;
            })
    }

    public get config() {
        return this.appConfig;
    }
}